import React, { useState, useEffect } from "react";

import { toast } from "react-toastify";

import * as IconsSVG from "../../../../assets/iconsSVG";
import images from "../../../../constants/images";

import MaterialUI from "../../../../material-UI";
import axiosLead from "../../../../services/lead";
import handleApiError from "../../../../utils/handleApiError";

import * as Styles from "../../styles";

interface Props {
  idLead?: string;
  idLeadCorretor: string;
  onClose: Function;
  open: boolean;
  isLeadScreen: boolean;
  hotRefreshFunc: Function;
}

const TransferForm: React.FC<Props> = ({
  idLead,
  idLeadCorretor,
  onClose,
  open,
  isLeadScreen,
  hotRefreshFunc,
}) => {
  const [corretores, setCorretores] = useState([]);
  const [value, setValue] = useState({
    idUsuario: "",
    apelido: "",
    idCorretor: "",
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [transferCommentCount, setTransferCommentCount] = useState<number>(0);
  const [motivo, setMotivo] = useState<string>("");
  const [isConcluded, setIsConcluded] = useState<boolean>(false);

  useEffect(() => {
    requestCorretores();
  }, []);

  const requestCorretores = async () => {
    try {
      const response = await axiosLead.GetCorretores();
      setCorretores(response.data.data);
    } catch (error: any) {
      handleApiError(error);
    }
  };

  const handleTransferComment = (comment: string) => {
    setMotivo(comment);
    setTransferCommentCount(comment?.length);
  };

  const transfLead = async () => {
    try {
      if (value.apelido === "") {
        toast.error("Selecione um corretor.");
        return;
      }
      setLoading(true);
      await axiosLead.transfLead({
        leads: [
          {
            idLead,
            idLeadCorretor,
          },
        ],
        idCorretorDestino: value.idCorretor,
        descricaoMotivoTransferencia: motivo,
      });
      toast.success("Lead transferido com sucesso.");
      if (isLeadScreen) {
        window.location.href = "/transferencia-concluida/transferido";
      } else {
        setIsConcluded(!isConcluded);
      }
    } catch (error: any) {
      handleApiError(error);
    }
    setLoading(false);
  };

  return (
    <>
      <Styles.TransferComponent style={{ minHeight: 320 }}>
        <Styles.Autocomplete
          id="combo-box-demo"
          options={corretores}
          renderInput={(params: any) => (
            <>
              <Styles.LabelText>Corretor de destino</Styles.LabelText>
              <Styles.TextField
                size="small"
                InputLabelProps={{ shrink: false }}
                variant="outlined"
                {...params}
                label="Corretor de destino"
              />
            </>
          )}
          getOptionLabel={(option: any) => option.apelido || ""}
          onChange={(event, newValue: any) => {
            setValue(newValue);
          }}
        />
        <Styles.MultLineField>
          <Styles.LabelText>Motivo</Styles.LabelText>
          <Styles.TextField
            onChange={(e: any) => handleTransferComment(e.target.value)}
            label="Multiline"
            variant="outlined"
            fullWidth
            multiline
            minRows={3}
            defaultValue="Default Value"
            value={motivo}
            inputProps={{ maxLength: 500 }}
          />
          <Styles.CountText>{transferCommentCount}/500</Styles.CountText>
        </Styles.MultLineField>
      </Styles.TransferComponent>
      <Styles.Footer>
        <Styles.FooterDialog>
          <Styles.Button variant="outlined" onClick={() => onClose(!open)}>
            Cancelar
          </Styles.Button>
          <Styles.Button
            className="transfer-btn"
            color="secondary"
            variant="contained"
            onClick={transfLead}
          >
            {loading ? <MaterialUI.CircularProgress /> : "Transferir"}
          </Styles.Button>
        </Styles.FooterDialog>
      </Styles.Footer>
      {isConcluded && (
        <Styles.ContainerConfirm>
          <Styles.HeaderContent>
            <Styles.BoxImgSuccess>
              <IconsSVG.SuccessIcon />
            </Styles.BoxImgSuccess>
            <Styles.HeaderTitle>Lead transferido</Styles.HeaderTitle>
          </Styles.HeaderContent>
          <Styles.InfoContent>
            <Styles.TitleInfo>
              Este lead não será mais exibido na sua carteira
            </Styles.TitleInfo>
            <Styles.BoxImgArt>
              <img src={images.transferSuccessArt} alt="Art Success" />
            </Styles.BoxImgArt>
            <Styles.LinkReturn
              onClick={() => {
                hotRefreshFunc();
                onClose(!open);
                setIsConcluded(!isConcluded);
              }}
            >
              Voltar para a carteira
            </Styles.LinkReturn>
          </Styles.InfoContent>
        </Styles.ContainerConfirm>
      )}
    </>
  );
};

export default TransferForm;
